import { render, staticRenderFns } from "./avg-total-messages-per-session.vue?vue&type=template&id=4f19debc&scoped=true&"
import script from "./avg-total-messages-per-session.vue?vue&type=script&lang=js&"
export * from "./avg-total-messages-per-session.vue?vue&type=script&lang=js&"
import style0 from "./avg-total-messages-per-session.vue?vue&type=style&index=0&id=4f19debc&scoped=true&lang=css&"
import style1 from "./avg-total-messages-per-session.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f19debc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/botter-dashbaord/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VProgressCircular})
